import { mapActions } from 'vuex';
import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { getElectricityPrepaidTransaction } from '~/api/electricity-prepaid';
import { getInvoices } from '~/api/invoices';

export default {
  methods: {
    ...mapActions({
      sendMessage: 'zopim/message/sendMessage',
    }),

    /**
     * Retrieve and show the token of an electricity-prepaid transaction
     * @command - [apicall] showUserElectricToken [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async showUserElectricToken(currentTrx = null) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        specialMessage: '[special-message] { "type": "electric-token", "token": "<token>" }',
        showUserElectricTokenError: '[apiresponse] showUserElectricTokenError [/apiresponse]',
      };

      try {
        // Get invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        const { data: electricityPrepaidData } = await getElectricityPrepaidTransaction(this.$axios, {
          transactionId: invoiceTrx.id,
        });
        const { token } = electricityPrepaidData;
        const formattedToken = `${token.substr(0, 4)}-${token.substr(4, 4)}-${token.substr(8, 4)}-${token.substr(
          12,
          4
        )}`;
        const finalResponse = responses.specialMessage.replace('<token>', formattedToken);
        this.$zopim.sendChatMsg(finalResponse);
        this.sendMessage({
          msg: finalResponse,
          nick: 'agent:trigger', // impersonate Acha Bot
          displayName: 'Acha',
        });
      } catch (error) {
        this.$zopim.sendChatMsg(responses.showUserElectricTokenError);
        console.error(
          '[ERROR] Something is wrong when trying to show the token of electricity-prepaid transaction',
          error
        );
      }
    },
  },
};
